import { createAsyncThunk } from '@reduxjs/toolkit';

import AuthApi from 'api/auth/AuthApi';

export const getAccountThunk = (authApi: AuthApi) =>
  createAsyncThunk('account/GetAccount', async () => {
    const account = await authApi.getCurrentAccount();
    const phone = account.phones.find((item: any) => item.value !== null);

    return { ...account, phone: phone.value };
  });
